export const messages = {
    "wre-dashboard.nav-menu.item.shared": "Jakaminen",
    "wre-dashboard.nav-menu.item.backups": "Varmuuskopiot",
    "wre-dashboard.nav-menu.item.machines": "Koneet",
    "wre-dashboard.nav-menu.item.account": "Tili",
    "wre-dashboard.search.input.hint": "Haku",
    "wre-dashboard.search.label.breadcrumb": "Hakutulokset",
    "wre-dashboard.search.message.empty": "Ei hakuasi vastaavia tuloksia",
    "wre-dashboard.side-bar.selected.title:plural": "{count} kohdetta valittu | {count} kohde valittu | {count} kohdetta valittu",
    "wre-dashboard.side-bar.backup-type.disk": "Levy",
    "wre-dashboard.side-bar.backup-type.file": "Tiedosto",
    "wre-dashboard.side-bar.backup-type.notarized": "Notarisoidut tiedostot ja kansiot",
    "wre-dashboard.side-bar.backup-type.exchange": "Sovellus – Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "Sovellus – Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "Sovellus – järjestelmän tila",
    "wre-dashboard.side-bar.backup-type.application": "Sovellus",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} jäljellä",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} käytetty",
    "wre-dashboard.space-indicator.label.unlimited": "Rajaton",
    "wre-dashboard.backups-table.column.name": "Nimi",
    "wre-dashboard.backups-table.column.size": "Koko",
    "wre-dashboard.backups-table.column.version": "Viimeisin varmuuskopio",
    "wre-dashboard.backups-table.message.no-backups": "Pilvessä ei ole vielä varmuuskopioita",
    "wre-dashboard.backups-sidebar.label.size": "Koko",
    "wre-dashboard.backups-sidebar.label.type": "Tyyppi",
    "wre-dashboard.backups-sidebar.label.version": "Viimeisin versio",
    "wre-dashboard.backups-sidebar.label.created": "Luotu",
    "wre-dashboard.backups-sidebar.label.machine": "Kone",
    "wre-dashboard.backups-sidebar.label.owner": "Omistaja",
    "wre-dashboard.content-table.column.name": "Nimi",
    "wre-dashboard.content-table.column.versions": "Versiot",
    "wre-dashboard.content-table.column.volumes": "Taltiot",
    "wre-dashboard.content-table.column.path": "Polku",
    "wre-dashboard.content-table.column.size": "Koko",
    "wre-dashboard.content-table.column.version": "Viimeisin versio",
    "wre-dashboard.content-table.action.versions": "Versiot",
    "wre-dashboard.content-table.action.restore": "Lataa",
    "wre-dashboard.content-table.action.share": "Jaa linkki",
    "wre-dashboard.content-table.label.size": "Koko",
    "wre-dashboard.content-table.label.created": "Luotu",
    "wre-dashboard.content-table.label.modified": "Muokattu",
    "wre-dashboard.content-table.message.empty-folder": "Kansio on tyhjä",
    "wre-dashboard.password-dialog-box.title.backup": "Salattu varmuuskopio",
    "wre-dashboard.password-dialog-box.title.archive": "Salattu arkisto",
    "wre-dashboard.password-dialog-box.message.backup": "Anna varmuuskopion {displayName} salasana",
    "wre-dashboard.password-dialog-box.message.archive": "Anna arkiston {displayName} salasana",
    "wre-dashboard.password-dialog-box.hint.password": "Salasana",
    "wre-dashboard.password-dialog-box.message.invalid-password": "Salasana on väärä",
    "wre-dashboard.form.button.open": "Avaa",
    "wre-dashboard.form.button.close": "Sulje",
    "wre-dashboard.form.button.cancel": "Peruuta",
    "wre-dashboard.form.button.delete": "Poista",
    "wre-dashboard.shared-content-table.column.name": "Nimi",
    "wre-dashboard.shared-content-table.column.location": "Sijainti",
    "wre-dashboard.shared-content-table.column.source": "Lähde",
    "wre-dashboard.shared-content-table.column.days": "Päivää",
    "wre-dashboard.shared-content-table.column.downloads": "Lataukset",
    "wre-dashboard.shared-content-table.column.shared": "Jaettu",
    "wre-dashboard.shared-content-table.label.shared": "Jaettu",
    "wre-dashboard.shared-content-table.label.backup": "Lähde",
    "wre-dashboard.shared-content-table.action.share": "Jaa linkki",
    "wre-dashboard.shared-content-table.action.settings": "Linkin asetukset",
    "wre-dashboard.shared-content-table.action.delete": "Poista linkki",
    "wre-dashboard.shared-content-table.action.delete-selected": "Poista linkit",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} vapaana määrästä {totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: Rajattomasti tilaa",
    "wre-dashboard.account-page.button.sign-out": "Kirjaudu ulos",
    "wre-dashboard.account-page.button.manage-subscription": "Lisenssin hallinta",
    "wre-dashboard.account-page.message.subscription.active": "{brandName} ‑tallennustilan lisenssi vanhentuu",
    "wre-dashboard.account-page.message.subscription.trial": "{brandName} ‑kokeiluversion aktiivisuusaika päättyy",
    "wre-dashboard.account-page.message.subscription.expired": "{brandName} ‑tilan lisenssi on vanhentunut",
    "wre-dashboard.account-page.message.worm-status.storage-full": "{brandName} ‑tallennustilasi on täynnä. Tietojen varmuuskopiointi tai arkistointi pilveen ei onnistu.",
    "wre-dashboard.account-page.message.worm-status.less-than": "Vapaata tilaa on alle {percent} %. Pian et voi käyttää {brandName} ‑palvelua.",
    "wre-dashboard.versions-dialog-box.title": "Tiedoston {fileName} versiot",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "Kopioi linkki",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "Linkin asetukset",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "Kuka tahansa, jolla on tämä linkki, voi tarkastella uusinta versiota tiedoista",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "Jaettu {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "Linkki kopioitu",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "Linkin kopiointivirhe",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "Poista linkki",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "Linkki ei enää toimi kenenkään käytössä",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "Poista linkit",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "Linkit eivät enää toimi keillään, joilla se on.",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "Linkin asetukset",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "Poista linkki",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "Valmis",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "Salasana",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "Aseta uusi salasana",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "Salasanasuojaus",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "Suojaa linkki salasanalla",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "Vanhentuminen",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "Latausmäärien rajoitus",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "Poista linkki käytöstä {splitMarker} päivän kuluttua | Poista linkki käytöstä {splitMarker} päivän kuluttua | Poista linkki käytöstä {splitMarker} päivän kuluttua",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "Poista linkki käytöstä {splitMarker} latauskerran jälkeen | Poista linkki käytöstä {splitMarker} latauskerran jälkeen | Poista linkki käytöstä {splitMarker} latauskerran jälkeen",
    "wre-dashboard.sub-accounts-dialog-box.title": "Tilit",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "Haku",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "Ei hakuasi vastaavia tuloksia",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "Nimi",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "Käyttö",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "Viimeisin varmuuskopio",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "Vanhentuu",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} vapaana määrästä {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "Volyymitilaus",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "Vanhentunut",
    "wre-dashboard.machines-table.column.name": "Nimi",
    "wre-dashboard.machines-table.column.size": "Koko",
    "wre-dashboard.machines-table.message.no-machines": "Pilvessä ei ole vielä koneita"
};
